import React from "react"
import {useTranslation} from "next-i18next"
import Typography from "../../reusable/Typography/Typography"
import Image from "next/image"
import NavLink from "../../reusable/components/NavLink/NavLink"
import urlParams from "../../../utility/UrlParams"

const RahmenContent = (): React.ReactElement => {
	const {t} = useTranslation("consultationPage")
	return (
		<>
			<Typography style={{marginBottom: "32px"}}
				variant="heading28To36"
				semanticTag="h2">{t("frame")}</Typography>
			<Typography className="mb-0 pb-3"
				variant="bodyLg"
				semanticTag="p">{t("frame-para-1")}</Typography>

			<Typography className="my-4"
				variant="heading20To28"
				semanticTag="h2">{t("frame-heading-2")}</Typography>
			<Typography variant="bodyLg"
				semanticTag="p">{t("frame-para-2")}</Typography>
			<div className="d-flex justify-content-center my-5">
				<Image src="/assets/images/consultation-page/rahmen.jpg"
					width={343}
					height={206}
					objectFit="contain"
					objectPosition="top right"/>
			</div>

			<Typography className="mb-4"
				variant="heading20To28"
				semanticTag="h2">{t("frame-heading-3")}</Typography>
			<Typography variant="bodyLg"
				semanticTag="p">{t("frame-para-3-1")}</Typography>
			<Typography className="mb-0 pb-3"
				variant="bodyLg"
				semanticTag="p">{t("frame-para-3-2")}</Typography>

			<Typography className="my-4"
				variant="heading20To28"
				semanticTag="h2">{t("frame-heading-4")}</Typography>
			<Typography variant="bodyLg"
				semanticTag="p">{t("frame-para-4-1")}</Typography>
			<Typography className="mb-4"
				variant="bodyLg"
				semanticTag="p">{t("frame-para-4-2")}</Typography>

			<NavLink className="mb-4 pb-3"
				label={t("frame-link-1")}
				params={{[urlParams.categories]: "e-trekking", [urlParams.brand]: "kalkhoff"}}
				isNewLinkDesign/>

			<Typography className="mb-4"
				variant="heading20To28"
				semanticTag="h2">{t("frame-heading-5")}</Typography>
			<Typography variant="bodyLg"
				semanticTag="p">{t("frame-para-5-1")}</Typography>
			<Typography className="mb-4"
				variant="bodyLg"
				semanticTag="p">{t("frame-para-5-2")}</Typography>

			<NavLink className="mb-4"
				label={t("frame-link-2")}
				params={{[urlParams.frameVariants]: "diamant"}}
				isNewLinkDesign/>
			<Typography className="mb-4"
				variant="bodyLg"
				semanticTag="p">{t("frame-para-6")}</Typography>

			<NavLink className="mb-4"
				label={t("frame-link-3")}
				params={{[urlParams.frameVariants]: "trapez"}}
				isNewLinkDesign/>
			<Typography className="mb-4"
				variant="bodyLg"
				semanticTag="p">{t("frame-para-7")}</Typography>

			<NavLink className="mb-4 pb-3"
				label={t("frame-link-4")}
				params={{[urlParams.frameVariants]: "wave"}}
				isNewLinkDesign/>
			<Typography className="mb-4"
				variant="heading20To28"
				semanticTag="h2">{t("frame-heading-6")}</Typography>
			<Typography className="mb-1"
				variant="bodyLg"
				semanticTag="p">{t("frame-para-8")}</Typography>
		</>)
}

export default RahmenContent
